<!-- Copyright (©) 2021. Care Control Systems Limited. All rights reserved. -->


<template>
    <div class="container">
        <h1>{{ label }}</h1>
    </div>
</template>


<script>

    // PROPS

        // Define props.
        const props = {
            label: {
                type: String,
                required: true
            }
        };

    //

    // EXPORT

        export default {
            name: 'PageTitle',
            props
        };

    //

</script>


<style lang="scss" scoped>

    // DEPENDENCIES

        // Theme.
        @import '/src/styles/theme.scss';

    //

    // ELEMENTS

        h1 {
            @extend .title;
            @media screen and (min-width: $medium) {
                text-align: left;
            }
            @media screen and (min-width: $large) {
                width: 80%;
                margin: .5rem auto;
                max-width: 1000px;
            }
        }

    //

    // CLASSES

        .container {
            text-align: center;
            background-color: $colour-light;
            margin: -.5rem -.5rem 1rem -.5rem;
        }

    //

</style>